import React, { Component } from 'react';
import http from '../modules/api';
import Button from '../modules/common/Button'; 
import WarningDialog from '../modules/dialogs/WarningDialog';
import Pagination from "react-js-pagination";

class ProductCategorySelector extends Component {
    constructor(props) {
        super(props);
        let rowcnt = 20;
        this.state = {
            categories: [
                // { category_cd: 'WOMEN', category_name: '여성의류', emoji: '👗', selected: false },
                // { category_cd: 'MEN', category_name: '남성의류', emoji: '👕', selected: false },
                // { category_cd: 'KIDS', category_name: '아동의류 / 용품', emoji: '🧸', selected: false },
                // { category_cd: 'JEWELRY', category_name: '쥬얼리 / 안경', emoji: '💍', selected: false },
                // { category_cd: 'SHOES', category_name: '슈즈 / 가방', emoji: '👟', selected: false },
                // { category_cd: 'FOOD', category_name: '식품 / 농수산물', emoji: '🍎', selected: false },
                // { category_cd: 'TOOL', category_name: '공구 / 기계용품', emoji: '🔧', selected: false },
                // { category_cd: 'UNIFORM', category_name: '유니폼 / 병원용품', emoji: '🥼', selected: false },
                // { category_cd: 'HEALTH', category_name: '건강 기능', emoji: '💊', selected: false },
                // { category_cd: 'BOOK', category_name: '도서', emoji: '📚', selected: false },
                // { category_cd: 'LIVING', category_name: '생활/인테리어', emoji: '🎀', selected: false },
                // { category_cd: 'BEAUTY', category_name: '화장품 / 미용', emoji: '💄', selected: false },
                // { category_cd: 'HOBBY', category_name: '취미 / 스포츠', emoji: '👙', selected: false },
                // { category_cd: 'TRAVEL', category_name: '여행', emoji: '✈️' , selected: false},
                // { category_cd: 'DIGITAL', category_name: '디지털/가전', emoji: '💻', selected: false },
                // { category_cd: 'CHINA', category_name: '중국상품판매', emoji: '🚢', selected: false },
                // { category_cd: 'PLATFORM', category_name: '플랫폼', emoji: '🏢', selected: false },
                // { category_cd: 'BRAND', category_name: '브랜드', emoji: '🧵', selected: false },
                // { category_cd: 'WHOLESALE', category_name: '도매 / 폐쇄몰', emoji: '🏠', selected: false }
            ],

            selected_code_cd: this.props.selected_category_cd || "",
            activePage: this.props.activePage || 1,
            rowcnt: rowcnt,
            startIdx: this.props.activePage ? (this.props.activePage * rowcnt) - rowcnt : 0,
            totalCnt: 0,
        };
    }

    componentDidMount() {
        this.getStoreCategoryList()
        this.pushNextButtonToFlexRight(".category-buttons", ".category-button", ".next-button", ".common_pagination");
        window.addEventListener("resize", () => {
            this.pushNextButtonToFlexRight(".category-buttons", ".category-button", ".next-button", ".common_pagination");
        });
    }

    getStoreCategoryList() {
        http.get("/rest/shop/rp/storeCategory/list"
            + "?start_idx=" + this.state.startIdx
            + "&row_cnt=" + this.state.rowcnt
        )
        .then(res => {
            if (res.data != null && res.data != '') {
                if (res.data.list && res.data.list.length > 0) {
                    let categories = res.data.list;
                    categories.forEach((item, idx) => {
                        if (item.category_cd === this.state.selected_code_cd) {
                            categories[idx]["selected"] = true;
                        }
                    });
                    this.setState({
                        categories: categories,
                        totalCnt: res.data.totalCnt
                    }, () => {
                        this.pushNextButtonToFlexRight(".category-buttons", ".category-button", ".next-button", ".common_pagination");
                    });
                }
            }
        })
        .catch(error => {
        });
    }

    handlePageChange(pageNumber) {
		// console.log(`active page is ${pageNumber}`);
		this.setState({activePage: pageNumber});
		this.state.startIdx = (pageNumber * this.state.rowcnt) - this.state.rowcnt;
        this.props.onPageChange(pageNumber);
		// console.log("this.state.startIdx :" + this.state.startIdx )
		this.getStoreCategoryList()
	}  

    onClickButton(idx) {
        const categories = [...this.state.categories];
        categories.map((item) => item.selected = false);
        categories[idx]["selected"] = true;
        this.setState({
            categories: categories,
            selected_code_cd: categories[idx].category_cd
        });
        this.props.onClicktCategorySelectButton(categories[idx].category_cd);
    }  

    onClickNextButton() {
        if (this.state.selected_code_cd) {
            this.setState({show_warning_dialog: false});
            this.props.onClickNextButton(this.state.selected_code_cd);
        } else {
            this.setState({show_warning_dialog: true}); 
        }
    }

    pushNextButtonToFlexRight(categoryContainerSelector, categoryButtonSelector, buttonWrapperSelector, paginationSelector) {
        const container = document.querySelector(categoryContainerSelector);
        const categoryButton = document.querySelector(categoryButtonSelector);
        const wrapper = document.querySelector(buttonWrapperSelector);
        const pagination = document.querySelector(paginationSelector);

        if (window.innerWidth >= 800) {
            container.style.minWidth = '1008px'; // 화면 너비가 800px 이상이면 1008px로 적용
        }
    
        // DOM 요소 유효성 먼저 체크
        if (!container || !categoryButton || !wrapper) return;
    
        const children = Array.from(container.children);
        const lines = [];
    
        // 줄 단위로 그룹화 (offsetTop 기준)
        children.forEach(el => {
            const top = el.offsetTop;
            let line = lines.find(line => Math.abs(line.top - top) < 1); // 오차 허용
            if (!line) {
                line = { top, elements: [] };
                lines.push(line);
            }
            line.elements.push(el);
        });
    
        // 각 줄의 가장 오른쪽 끝 계산
        const lineWidths = lines.map(line =>
            Math.max(...line.elements.map(el => el.offsetLeft + el.offsetWidth))
        );
    
        const maxLineWidth = Math.max(...lineWidths);
        console.log("maxLineWidth", maxLineWidth);
    
        const style = getComputedStyle(container);
        const gap = parseFloat(style.gap) || 0;
    
        const targetWidth = maxLineWidth - categoryButton.offsetWidth - gap - (gap / 2);
        wrapper.style.width = `${targetWidth}px`;
        if (pagination) pagination.style.width = `${targetWidth}px`;

        const computedMinWidth = parseFloat(getComputedStyle(container).minWidth) || 0;
        console.log("targetWidth", targetWidth)
        console.log("computedMinWidth", computedMinWidth)
        if (computedMinWidth > targetWidth) {
            container.style.minWidth = `${targetWidth}px`;
        };
    }
      
      
  render() {
    const {categories} = this.state;

    return (
        <>
            <div className="ProductCategorySelector">
                <h3>쇼핑몰에 주로 판매하는 상품은 무엇인가요?</h3>
                <div style={{ maxWidth: "100%", overflow:"auto"}}>
                    <div className="category-buttons">
                    {categories.map((item, idx) => (
                        <button className={"category-button" + (item.selected ? ' selected' : '')} 
                            key={item.category_cd} 
                            id={item.category_cd} 
                            onClick={() => {this.onClickButton(idx)}}
                        >
                            {
                                item.emoji
                                && 
                                <>
                                    <span className="icon">
                                        {
                                            item.emoji?.startsWith('<svg') 
                                            ? <span dangerouslySetInnerHTML={{ __html: item.emoji }} />
                                            : item.emoji
                                        }
                                    </span>
                                </>
                            }
                            <span className='text'>{item.category_name}</span>
                        </button>
                    ))}
                    </div>
                </div>
                {
                    Number(this.state.totalCnt) > 0
                    ?
                    <div class="common_pagination" style={{marginTop:"14px"}}>
                        <Pagination
                            firstPageText={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.35627 13.3562C8.26147 13.4501 8.13344 13.5028 8.00002 13.5028C7.8666 13.5028 7.73857 13.4501 7.64377 13.3562L2.64377 8.35623C2.55136 8.26066 2.4997 8.13292 2.4997 7.99998C2.4997 7.86704 2.55136 7.7393 2.64377 7.64373L7.64377 2.64373C7.74092 2.564 7.86425 2.52325 7.98977 2.52942C8.1153 2.53558 8.23405 2.58822 8.32291 2.67709C8.41178 2.76595 8.46442 2.8847 8.47058 3.01023C8.47675 3.13575 8.436 3.25908 8.35627 3.35623L3.70627 7.99998L8.35627 12.6437C8.45016 12.7385 8.50283 12.8666 8.50283 13C8.50283 13.1334 8.45016 13.2614 8.35627 13.3562ZM7.64377 7.64373C7.55136 7.7393 7.4997 7.86704 7.4997 7.99998C7.4997 8.13292 7.55136 8.26066 7.64377 8.35623L12.6438 13.3562C12.7409 13.436 12.8643 13.4767 12.9898 13.4705C13.1153 13.4644 13.234 13.4117 13.3229 13.3229C13.4118 13.234 13.4644 13.1153 13.4706 12.9897C13.4767 12.8642 13.436 12.7409 13.3563 12.6437L8.70627 7.99998L13.3563 3.35623C13.436 3.25908 13.4767 3.13575 13.4706 3.01023C13.4644 2.8847 13.4118 2.76595 13.3229 2.67709C13.234 2.58822 13.1153 2.53558 12.9898 2.52942C12.8642 2.52325 12.7409 2.564 12.6438 2.64373L7.64377 7.64373Z" fill="#8B8B8B"/>
                            </svg>}
                            prevPageText={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.50002 7.99998C4.50182 7.86746 4.55309 7.74039 4.64377 7.64373L9.64377 2.64373C9.74092 2.564 9.86425 2.52325 9.98977 2.52942C10.1153 2.53558 10.234 2.58822 10.3229 2.67709C10.4118 2.76595 10.4644 2.8847 10.4706 3.01023C10.4767 3.13575 10.436 3.25908 10.3563 3.35623L5.70627 7.99998L10.3563 12.6437C10.436 12.7409 10.4767 12.8642 10.4706 12.9897C10.4644 13.1153 10.4118 13.234 10.3229 13.3229C10.234 13.4117 10.1153 13.4644 9.98977 13.4705C9.86425 13.4767 9.74092 13.436 9.64377 13.3562L4.64377 8.35623C4.55309 8.25957 4.50182 8.1325 4.50002 7.99998Z" fill="#8B8B8B"/>
                            </svg>}
                            nextPageText={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.5 8.00002C11.4982 8.13254 11.4469 8.25961 11.3562 8.35627L6.35623 13.3563C6.25908 13.436 6.13575 13.4767 6.01023 13.4706C5.8847 13.4644 5.76595 13.4118 5.67709 13.3229C5.58822 13.234 5.53558 13.1153 5.52942 12.9898C5.52325 12.8642 5.564 12.7409 5.64373 12.6438L10.2937 8.00002L5.64373 3.35627C5.564 3.25912 5.52325 3.13579 5.52942 3.01026C5.53558 2.88474 5.58822 2.76599 5.67709 2.67712C5.76596 2.58826 5.8847 2.53562 6.01023 2.52946C6.13575 2.52329 6.25908 2.56404 6.35623 2.64377L11.3562 7.64377C11.4469 7.74043 11.4982 7.8675 11.5 8.00002Z" fill="#8B8B8B"/>
                            </svg>}
                            lastPageText={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.64373 2.64377C7.73853 2.54988 7.86656 2.49721 7.99998 2.49721C8.1334 2.49721 8.26143 2.54988 8.35623 2.64377L13.3562 7.64377C13.4486 7.73934 13.5003 7.86708 13.5003 8.00002C13.5003 8.13296 13.4486 8.2607 13.3562 8.35627L8.35623 13.3563C8.25908 13.436 8.13575 13.4767 8.01023 13.4706C7.8847 13.4644 7.76595 13.4118 7.67709 13.3229C7.58822 13.234 7.53558 13.1153 7.52942 12.9898C7.52325 12.8642 7.564 12.7409 7.64373 12.6438L12.2937 8.00002L7.64373 3.35627C7.54984 3.26147 7.49717 3.13344 7.49717 3.00002C7.49717 2.8666 7.54984 2.73857 7.64373 2.64377ZM8.35623 8.35627C8.44864 8.2607 8.5003 8.13296 8.5003 8.00002C8.5003 7.86708 8.44864 7.73934 8.35623 7.64377L3.35623 2.64377C3.25908 2.56404 3.13575 2.52329 3.01022 2.52946C2.8847 2.53562 2.76595 2.58826 2.67709 2.67712C2.58822 2.76599 2.53558 2.88474 2.52942 3.01026C2.52325 3.13579 2.564 3.25912 2.64373 3.35627L7.29373 8.00002L2.64373 12.6438C2.564 12.7409 2.52325 12.8642 2.52942 12.9898C2.53558 13.1153 2.58822 13.234 2.67709 13.3229C2.76595 13.4118 2.8847 13.4644 3.01023 13.4706C3.13575 13.4767 3.25908 13.436 3.35623 13.3563L8.35623 8.35627Z" fill="#8B8B8B"/>
                            </svg>}
                            activePage={this.state.activePage}
                            itemsCountPerPage={this.state.rowcnt}
                            totalItemsCount={this.state.totalCnt}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange.bind(this)}
                        />
                    </div>    
                    : ""
                }
                <div className="next-button">
                    <Button className="next-button-element" width="236px" height="40px" fontSize="15px"
                        children={<span>다음</span>}
                        onClick={() => {this.onClickNextButton()}}
                    >
                    </Button>
                </div>
            </div>
            {
                this.state.show_warning_dialog
                && <WarningDialog
                    content={"항목을 선택해 주새요."}
                    button_list={[{
                        title : "확인",
                        event_method : () => { this.setState({show_warning_dialog: false}) }
                    }]}
                />
            }
        </>
    );
  }
}

export default ProductCategorySelector;